import { render } from "./App.vue?vue&type=template&id=00835cca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/css/App.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__